import React, { useState } from 'react';
import * as queries from '../graphql/queries';
import { useParams } from "react-router-dom";
import { Connect } from 'aws-amplify-react';
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import formatTRT from '../lib/formatTRT';
import bent from 'bent';

const getDownload = async (sid) => {
    const composition = await API.graphql(graphqlOperation(queries.getComposition, {sid}));
    console.log(composition.data.getComposition.mediaLocation)
    window.location.href = composition.data.getComposition.mediaLocation;
}

const downloadRaw = async (bucket, key) => {

    const fileURL = await API.get('IntvAPI', `admin/downloadRaw/${bucket}/${key}`);

    console.log(fileURL.mediaLocation)

    window.location.href = fileURL.mediaLocation;
}

const RoomDetail = () => {
    const { room_id } = useParams();
    const [lastUpdate, setLastUpdate] = useState(Date.now())

    const forceComplete = async (id) => {
        if (window.confirm("This overwrites the status to appear as Complete.  It does not have any effect on files.  Please be certain that the transcode really is finished.")) {
            const force = await API.post('IntvAPI', 'admin/forceComplete', {body:{id}})

            console.log(force)

            setLastUpdate(Date.now())
        }
    }

    return <Connect query={graphqlOperation(queries.getRoom, {id: room_id})} key={lastUpdate}>
        {({loading, error, data}) => {
            if (loading) return <>loading...</>
            if (error) return <>ERROR: {error}</>

            const room = data.getRoom;

            const reprocessRecordings = async e => {
                console.log(`Reprocessing recordings for Twilio room sid ${room.sid}`)
                const reprocessCall = bent(`https://${process.env.REACT_APP_API_DOMAIN}/`, 'POST', 'json', 200);
                await reprocessCall('room/reprocess', {roomSid: room.sid})
                    .then(res => {
                        console.log("reprocessed room:", res);
                        alert("Reprocess request submitted.");
                    })
                    .catch(err => {
                        console.log("error reprocessing room", err);
                        alert("There was an error submitting the reprocess request.");
                    })
            }

            return <>
                <h3>{room.title} ({room.status})</h3>
                <h4>Room ID: {room.id}</h4>
                <h4>Twilio SID: {room.sid}</h4>
                <div>
                    <p><strong>Started:</strong> {moment.unix(room.started).format("M/DD/YYYY - h:mm:ss a")}</p>
                    <strong>Processed Recordings:</strong>
                    <br/>
                    <button id="reprocess-button" onClick={reprocessRecordings}>Reprocess</button>
                    <ul>
                        {room.processedRecordings && room.processedRecordings.map(rec => <li key={rec.id}>{rec.participant} ({formatTRT(rec.duration)})
                        &nbsp;-&nbsp;
                        {rec.status === "Completed"?
                        <button onClick={() => getDownload(rec.id)}>Download</button>
                        :<>
                            {rec.status}: {rec.pctDone}% Complete
                            &nbsp;-&nbsp;
                            <button onClick={() => forceComplete(rec.id)}>Force Complete</button>
                        </>
                        }
                        </li>)}
                    </ul>
                    <strong>Raw Recordings:</strong>
                    <ul>
                        {room.rawRecordings.sort((a,b) => {
                            if (a.participant_sid > b.participant_sid) return 1;
                            if (a.participant_sid < b.participant_sid) return -1;
                            return 0;
                        }).map(rec => <li key={rec.rec_sid}><strong>{rec.participant_sid}</strong><br/>{rec.rec_sid} ({rec.track_type})
                              <ul>
                                {(rec.track_type === "audio")?<>
                                    <li>RAW: MKA Audio: <button onClick={() => downloadRaw('raw', rec.rec_sid + '.mka' + '/' + room.sid)}>Download</button></li>
                                    {/* <li>Transcoded: WAV Audio: <button onClick={() => downloadRaw('rec', rec.participant_sid + '/' + room.sid)}>Download</button></li> */}
                                </>:<li>RAW: MKV Video: <button onClick={() => downloadRaw('raw', rec.rec_sid + '.mkv' + '/' + room.sid)}>Download</button></li>}
                            </ul>
                        </li>)}
                    </ul>
                </div>
            </>
        }}
    </Connect>
}

export default RoomDetail;
